<p-drawer
  styleClass="floatbar"
  [(visible)]="visible"
  (onHide)="onHide()"
  [position]="position"
  [style]="{ width: '600px' }"
  [dismissible]="false"
  [showCloseIcon]="false"
  [closeOnEscape]="false"
  >
  <form [formGroup]="form" (ngSubmit)="save($event)" class="sidebar-content">
    <header class="floatbar-header">
      <div class="row">
        @if (isNew) {
          <h2 class="no-mg">
            {{ 'MESSAGES.FORM_LABELS.CREATE_NEW_RULE_BASE_MESSAGE' | translate }}
          </h2>
        }
        @if (!isNew) {
          <h2 class="no-mg">
            {{ 'MESSAGES.FORM_LABELS.UPDATE_RULE_BASE_MESSAGE' | translate }}
          </h2>
        }
        <div class="row grid-xsm">
          <div class="cell">
            <button type="button" class="btn btn-link" (click)="cancel()">
              {{ 'COMMON.BUTTONS.CLOSE' | translate }}
            </button>
          </div>
          <div class="cell">
            @if (isNew) {
              <button [disabled]="!this.form.valid" type="submit" class="btn btn-primary" data-testid="rule-message-submit">{{ 'COMMON.BUTTONS.CREATE' | translate }}</button>
            }
            @if (!isNew) {
              <button [disabled]="!this.form.valid" type="submit" class="btn btn-primary" data-testid="rule-message-submit">{{ 'COMMON.BUTTONS.SAVE' | translate }}</button>
            }
          </div>
        </div>
      </div>
    </header>
    <div class="floatbar-section">
      <div class="divider-h mb-5"></div>
      <div class="row grid-sm">
        <div class="cell fg-1 fw-50">
          <app-yabi-input
            type="multiselect"
            [form]="form"
            formControlNameInput="trigger"
            [placeholderByLabel]="true"
            label="MESSAGES.FORMS.FIELD_LABELS.TRIGGERS"
            [listConfig]="triggersListConfig"
            class="p-input-filled"
            id="rule-message-triggers"
          ></app-yabi-input>
          @if (isOvertimeTrigger) {
            <small class="color-gray2" style="display: block" data-testid="rule-overtime-hint">{{ 'MESSAGES.FORMS.HINTS.OVERTIME' | translate }}</small>
          }
        </div>
        <div [class.fg-1]="!isLoginTriggerSelected" [class.fw-50]="!isLoginTriggerSelected" [class.fw-50]="isLoginTriggerSelected" class="cell">
          <app-yabi-input
            type="radio"
            [form]="form"
            formControlNameInput="platform"
            label="MESSAGES.FORMS.FIELD_LABELS.PLATFORM"
            [radioConfig]="platformRadioConfig"
            class="p-input-filled"
            id="rule-message-platrform"
          ></app-yabi-input>
        </div>
      </div>
      <div class="row grid-sm">
        @if (!isLoginTriggerSelected) {
          <div class="cell fg-1 fw-50">
            <app-yabi-input
              type="multiselect"
              [form]="form"
              formControlNameInput="event_id"
              [placeholderByLabel]="true"
              [label]="activeModuleName === 'sportsandculture' ? 'SIDEBAR.EVENTS' : 'SYSTEM.ENTITY_NAMES.DOMAINS'"
              [listConfig]="eventsListConfig"
              class="p-input-filled"
              id="rule-message-events"
            ></app-yabi-input>
          </div>
        }
        @if (!isLoginTriggerSelected) {
          <div class="cell fg-1 fw-50">
            <app-yabi-input
              type="multiselect"
              [form]="form"
              formControlNameInput="areas"
              [placeholderByLabel]="true"
              label="SYSTEM.ENTITY_NAMES.AREAS"
              [listConfig]="areasListConfig"
              class="p-input-filled"
              id="rule-message-areas"
              [labelCallbackFunction]="areasCallbackValue"
            ></app-yabi-input>
          </div>
        }
      </div>
      <div class="row grid-sm">
        <div class="cell fg-1 fw-50">
          <app-yabi-input
            type="multiselect"
            [form]="form"
            formControlNameInput="initiator"
            [placeholderByLabel]="true"
            label="MESSAGES.FORMS.FIELD_LABELS.INITIATORS"
            [listConfig]="initiatorListConfig"
            class="p-input-filled"
            id="rule-message-initiator"
          ></app-yabi-input>
        </div>
        @if (isKeyera) {
          <div class="cell fg-1 fw-50">
            <app-yabi-input
              type="multiselect"
              [form]="form"
              formControlNameInput="target"
              [placeholderByLabel]="true"
              label="MESSAGES.FORMS.FIELD_LABELS.TARGET"
              [listConfig]="targetListConfig"
              class="p-input-filled"
              id="rule-message-target"
              data-testid="rule-message-target"
            ></app-yabi-input>
          </div>
        }
      </div>
      @if (isKeyera) {
        <div class="row grid-sm">
          <div class="cell fg-1 fw-50">
            <app-yabi-input
              type="multiselect"
              [form]="form"
              formControlNameInput="target_ids"
              (onLazyLoad)="extraReceiversLazyLoading($event)"
              [placeholderByLabel]="true"
              label="MESSAGES.FORMS.FIELD_LABELS.RECIPIENTS"
              [listConfig]="extraReceiversListConfig"
              class="p-input-filled"
              id="rule-message-target-ids"
            ></app-yabi-input>
          </div>
          <div class="cell fg-1 fw-50">
            <app-yabi-input
              type="multiselect"
              [form]="form"
              formControlNameInput="target_client_role_ids"
              [placeholderByLabel]="true"
              label="MESSAGES.FORMS.FIELD_LABELS.CLIENT_ROLES"
              [listConfig]="clientRolesListConfig"
              class="p-input-filled"
              id="rule-message-target-client-roles"
              data-testid="rule-message-target-client-roles"
              [labelCallbackFunction]="clientRoleCallbackValue"
            ></app-yabi-input>
          </div>
        </div>
      }
      @if (isLoginTriggerSelected) {
        <div class="row grid-sm">
          <div class="cell fg-1 fw-50">
            <app-yabi-input
              type="multiselect"
              [form]="form"
              formControlNameInput="trigger_user_ids"
              [placeholderByLabel]="false"
              label="MESSAGES.FORMS.FIELD_LABELS.TRIGGER_USERS"
              [listConfig]="cportalUsersListConfig"
              class="p-input-filled"
              id="rule-message-trigger-users"
            ></app-yabi-input>
          </div>
        </div>
      }
      <div class="row grid-sm">
        <div class="cell fg-1 fw-100">
          <app-yabi-input
            type="text"
            [form]="form"
            formControlNameInput="title"
            [placeholderByLabel]="true"
            label="WRITE_MESSAGE.MESSAGE_TITLE"
            class="p-input-filled"
            id="rule-message-title"
          ></app-yabi-input>
        </div>
      </div>
      <div class="row grid-sm">
        <div class="cell fg-1 fw-100">
          <app-yabi-input
            type="textarea"
            [form]="form"
            formControlNameInput="body"
            [textAreaRows]="isKeyera && !isTheInvitedInitiatorSelected ? 22 : isKeyera && isTheInvitedInitiatorSelected ? 20 : 28"
            [placeholderByLabel]="true"
            label="WRITE_MESSAGE.MESSAGE"
            class="p-input-filled"
            id="rule-message-body"
          ></app-yabi-input>
        </div>
      </div>
    </div>

    @if (!isNew) {
      <div class="cell" style="align-items: flex-end; display: flex; flex-direction: column; padding: 0 16px">
        <button (click)="delete()" [disabled]="!!model.employees?.length" type="button" class="btn btn-danger-link active">
          <i aria-hidden="true" class="pi pi-trash"></i> {{ 'COMMON.BUTTONS.DELETE' | translate }}
        </button>
      </div>
    }
  </form>
</p-drawer>
